import { FC, useMemo } from 'react';

import { SIZE } from 'utils/constants';
import { cn } from 'utils/helpers';
import { cva } from 'class-variance-authority';
import { Tooltip } from 'ui/components/common';

import Avatar from './Avatar';

export interface PROPS {
  // TODO: add User interface
  users: any[];
  className?: string;
  size?: SIZE;
}

const avatarClassnames = cva(['border-2 border-fill-tertiary'], {
  variants: {
    size: {
      [SIZE.Small]: ['ml-[-6px]'],
      [SIZE.Medium]: ['ml-[-10px]'],
      [SIZE.Large]: ['ml-[-14px]'],
    },
  },
  defaultVariants: {
    size: SIZE.Medium,
  },
});

const AvatarGroup: FC<PROPS> = ({ users = [], className, size }) => {
  const remaining = useMemo(() => {
    const rem = users.length - 3;
    return !(rem > 0) ? null : (
      <Avatar
        text={`+${rem}`}
        size={size}
        className={cn(
          avatarClassnames({ size }),
          'text-info-base bg-[#F7FAFF]',
        )}
      />
    );
  }, [size, users.length]);

  return (
    <div className={cn('flex items-center h-full', className)}>
      {users?.slice?.(0, 3).map((user, index) => (
        <Tooltip
          strategy="fixed"
          theme={'dark'}
          key={user?._id}
          title={user.fullName}
        >
          <Avatar
            size={size}
            user={user}
            className={cn(avatarClassnames({ size }), index === 0 && '!ml-0')}
          />
        </Tooltip>
      ))}
      {remaining}
    </div>
  );
};

export default AvatarGroup;
